import React from 'react';

import { Link } from '@klarna/bubble-ui';

export const LinkWithoutHref = ({ children, disabled = false, ...props }) => (
  <span style={{ cursor: disabled ? 'inherit' : 'pointer' }}>
    <Link disabled={disabled} {...props}>
      {children}
    </Link>
  </span>
);

LinkWithoutHref.propTypes = Link.propTypes;
